import React from 'react';
import { View } from 'react-native';
import { usePathname } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/gluestack/text';
import { useSignalR } from '@/components/providers/SignalRProvider';

/**
 * Thin, non-blocking banner shown below the header on the realtime-driven tabs
 * (messages, notifications) while the connection is unavailable. Distinguishes
 * "device offline" from "reconnecting"; renders nothing otherwise.
 *
 * The debounce that decides when to show it lives in SignalRProvider, so the
 * status persists across navigation — no re-delay when a screen remounts.
 */
export function ConnectionBanner() {
  const { t } = useTranslation();
  const { connectionBannerStatus } = useSignalR();
  const pathname = usePathname();

  const onRealtimeRoute =
    pathname.startsWith('/messages') || pathname.startsWith('/notifications');

  if (!onRealtimeRoute || !connectionBannerStatus) return null;

  return (
    <View className="flex-row items-center justify-center gap-3 bg-secondary-700 px-4 py-2.5 dark:bg-secondary-200">
      <Text size="sm" className="font-medium text-secondary-200 dark:text-secondary-800">
        {connectionBannerStatus === 'offline'
          ? t('common.connection.offline')
          : t('common.connection.connecting')}
      </Text>
    </View>
  );
}
